import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  CardText,
} from 'material-ui/Card';
import DatePicker from 'material-ui/DatePicker';
import { theme } from '../../utils/getTheme';

const DateFilter = ({
  addFilter,
  collegeRegisterations,
}) => (
  <Card>
      <CardHeader
        title="Dates"
        actAsExpander
        showExpandableButton
        titleColor={theme.primary1Color}
      />
      <CardText expandable>
        <DatePicker
          floatingLabelText="Start Date"
          onChange={(_, date) => {
            addFilter(date, collegeRegisterations, 'timestamp', 'startDate');
          }}
        />
        <DatePicker
          floatingLabelText="End Date"
          onChange={(_, date) => {
            addFilter(date, collegeRegisterations, 'timestamp', 'endDate');
          }}
        />
      </CardText>
    </Card>
  );

DateFilter.propTypes = {
  addFilter: PropTypes.func.isRequired,
  collegeRegisterations: PropTypes.array.isRequired, // eslint-disable-line
};


export default DateFilter;



// WEBPACK FOOTER //
// ./src/components/Filters/DateFilter.js